// extracted by mini-css-extract-plugin
export default {"list":"LinkedEmails_list__d0P2h","row":"LinkedEmails_row__mJuS6","emailText":"LinkedEmails_emailText__oeacp","button":"LinkedEmails_button__FHn7X"};